export const GET_ALL_DATA_SUCCESS = "all_Data/get/success";

export const GET_PRODUCTS_LOADING = "product/get/loading";
export const GET_PRODUCTS_SUCCESS = "product/get/success";
export const GET_PRODUCTS_ERROR = "product/get/error";

export const CLEAR_PARAMS_LOADING = "clear_params/loading";
export const CLEAR_PARAMS_SUCCESS = "clear_params/success";
export const CLEAR_PARAMS_ERROR = "clear_params/error";
